<script>
	import Button,{ Label } from '@smui/button';
	import { onMount } from 'svelte';
	import { HsvPicker } from 'svelte-color-picker';
	import { get } from "svelte/store";
	import AppStore from "../../AppStore";
	import LoadState from "../../Enums/LoadState";
	import ColorHelper from "../../Helpers/ColorHelper";
	import MapControlType from "../../Map/Enums/MapControlType";
	import MapStore from "../../Map/Store";
	import SpinnerButton from "../../UI/Admin/SpinnerButton.svelte";
	import { initFilters,updateShippingLaneFilters } from "../ShippingLaneFilter/FilterFunctions";
	import ShippingLanesFilter from "../ShippingLaneFilter/ShippingLaneFilter.svelte";
	import ShippingLaneFilterType from "../ShippingLaneFilter/ShippingLaneFilterType";
	import ShippingLanesSetResolution from "../ShippingLanesSetResolution";
	import ShippingLanesSetType from '../ShippingLanesSetType';
	import ShippingLanesSetTypeData from "../ShippingLanesSetTypeData";
	import ShippingLanesStore from "../Store";

    export let set = {};
    export let index = 0;
    export let availableSets = [];

    let flagFilters = set.flagFilters;
	let shipFilters = set.shipTypeFilters;
	let currentFlagFilter = set.currentlySelectedFlag;
	let currentShipFilter = set.currentlySelectedShiptype;
    let setType = set.type;

    onMount( () => {
        initFilters(set);
    })

    let toggleColorPickerVisibility = (set) => {
		set.meta.colorPickVisible = !set.meta.colorPickVisible;
		set.lastUpdated.set(Date.now());
	}

	const resKeys = Object.keys(ShippingLanesSetResolution);
	const resValues = Object.values(ShippingLanesSetResolution);

	let getResolutionName = (res) => {
		let name = resKeys[resValues.indexOf(res)];
		return name.substr(0, 1) + (name.substr(1).toLowerCase());
	};

    let updateMinPercentage = (set, e) => {
		if (!Number.isNaN(parseFloat(e.target.value))) {
			e.target.classList.remove("sml-input-err");
			set.minValuePercentage.set(e.target.value/100);
		}
		else {
			e.target.classList.add("sml-input-err");
		}
	}
	let updateMaxValue = (set, e) => {
		if (!Number.isNaN(parseFloat(e.target.value))) {
			e.target.classList.remove("sml-input-err");
			set.maxValue.set(e.target.value);
		}
		else {
			e.target.classList.add("sml-input-err");
		}
	}

	function handleFilterChange(event) {
		let filterType = event.detail.filterType;
		let selectedFilter = event.detail.selectedFilter;
		updateShippingLaneFilters(set, filterType, selectedFilter);
	}

</script>

<div class='title-area'>
    <h3>Query #{index+1}</h3>
    <button class='btn-sml bg-error' on:click={()=>{ set.destroy(); }}>delete</button>
</div>
<div class="shipping-lanes-query-container">
    <table>
        <tr>
            <td width="40%">Type: </td>
            <td>
                {#if set.loadState === LoadState.INIT}
                    <select value={get(set.type)} on:change={(e)=>{
                        set.type.set(e.target.value);
                        set.color = ShippingLanesSetTypeData[e.target.value].defaultColor;
                        set.lastUpdated.set(Date.now());
                    }}>
                    {#each availableSets as value}
                        <option value={value}>{ShippingLanesSetTypeData[value].name}</option>
                    {/each}
                    </select>
                {:else}
                    {ShippingLanesSetTypeData[get(set.type)].name}
                {/if}
            </td>
        </tr>
        {#if $setType === ShippingLanesSetType.SHIPPING}
            <ShippingLanesFilter
                filterType= {ShippingLaneFilterType.FLAG}
                filterHeader="Flag"
                filterOptions={$flagFilters}
                currentFilter={$currentFlagFilter}
                submitted={set.loadState !== LoadState.INIT}
                on:shippingLanesFilterChange={handleFilterChange}
            />
            <ShippingLanesFilter
                filterType= {ShippingLaneFilterType.SHIP_TYPE}
                filterHeader="Vessel Type"
                filterOptions={$shipFilters}
                currentFilter={$currentShipFilter}
                submitted={set.loadState !== LoadState.INIT}
                on:shippingLanesFilterChange={handleFilterChange}
            />
        {/if}
        <tr>
            <td width="40%">Resolution: </td>
            <td>
                {#if set.loadState === LoadState.INIT}
                    {#if set.autoResolution}
                        AUTO: {getResolutionName(get(set.resolution))}
                    {:else}
                        <select value={get(set.resolution)} on:change={(e)=>{
                            set.resolution.set(parseFloat(e.target.value));
                            set.lastUpdated.set(Date.now());
                        }}>
                        {#each Object.keys(ShippingLanesSetResolution) as key}
                            <option value={ShippingLanesSetResolution[key]}>{getResolutionName(ShippingLanesSetResolution[key])}</option>
                        {/each}
                        </select>
                    {/if}
                {:else}
                    {getResolutionName(get(set.resolution))}
                {/if}
            </td>
        </tr>
        <tr>
            <td width="40%">Area: </td>
            <td>({set._tl}) to ({set._br}) {#if set.loadState === LoadState.INIT}(<a href="/" on:click={(e)=>{
                e.preventDefault();
                AppStore.snackbar.start("Draw a rectangle to set.", "success");

                let prev = get(MapStore.control);
                MapStore.controlData.boxPicker.visible.set(true);
                MapStore.control.set(MapControlType.BOX_PICKER);
                const unsubscribe = MapStore.controlData.boxPicker.obj.end.subscribe((end)=>{
                    if (get(MapStore.controlData.boxPicker.obj.dragging)) {
                        MapStore.controlData.boxPicker.obj.roundTo.set(1);
                        const bbox = MapStore.controlData.boxPicker.obj.getBBox();
                        set.setBounds(bbox[0], bbox[1]);
                        MapStore.control.set(prev);
                        MapStore.controlData.boxPicker.visible.set(false);
                        set.lastUpdated.set(Date.now());
                        ShippingLanesStore.update();
                        unsubscribe();
                    }
                });
            }}>draw</a>){/if}</td>
        </tr>
    </table>
    {#if set.error}
        <p style="color:red;">
            {#each set.errors as tileState}
                <b>Tile failed</b> - {tileState.message} - <a href="/" on:click|preventDefault={()=>{
                    set.retryTile(tileState.extent);
                }}>retry?</a><br/>
            {/each}
        </p>
    {/if}


    {#if set.loadState === LoadState.INIT}
        <Button on:click={()=>{ set.start(); }} color="secondary" variant="unelevated" style="width:100%;margin-top:10px;" disabled={set.loadState === LoadState.LOADING}><Label>Submit</Label></Button>
    {/if}
    {#if set.loadState === LoadState.LOADING}
        <div>
            <SpinnerButton>
                <p class="p-0">{set.percentageComplete}%</p>
            </SpinnerButton>
        </div>
    {:else if set.loadState === LoadState.LOADED}
        <h4>Results</h4>
        <table>
            <tr>
                <td width="40%">Color: </td>
                <td>
                    <div class='color-sq' style="background-color: rgba({set.color[0]*255}, {set.color[1]*255},{set.color[2]*255}, {set.color[3]});"
                        on:click={()=>{toggleColorPickerVisibility(set);}}>
                    </div>
                    (<a href="/" on:click={(e)=>{ e.preventDefault(); toggleColorPickerVisibility(set); }}>{#if !set.meta.colorPickVisible}edit{:else}close{/if}</a>)
                </td>
            </tr>
            {#if set.meta.colorPickVisible}
                <tr>
                    <td colspan='2'>
                        <HsvPicker on:colorChange={(rgba) => {
                            set.color[0] = rgba.detail.r/255.0;
                            set.color[1] = rgba.detail.g/255.0;
                            set.color[2] = rgba.detail.b/255.0;
                            set.color[3] = rgba.detail.a;
                            set.lastUpdated.set(Date.now());
                        }} startColor={ColorHelper.rgbToHex(set.color[0], set.color[1], set.color[2])}/>
                    </td>
                </tr>
            {/if}
            <tr>
                <td width="40%">Max Value: </td>
                <td>
                    {#if get(set.overrideMaxValue)}
                        <input
                            class="sml-input"
                            type="text"
                            value={get(set.maxValue)}
                            on:change={(e)=>{ updateMaxValue(set, e); }}
                            on:keyup={(e)=>{ updateMaxValue(set, e); }}
                        /> / {get(set.actualMaxValue)}
                    {:else}
                        {get(set.actualMaxValue)}
                    {/if}
                </td>
            </tr>
            <tr>
                <td width="40%">Min Value: </td>
                <td>
                    <input
                        class="sml-input"
                        type="text"
                        value={Math.ceil(get(set.minValuePercentage)*100)}
                        on:change={(e)=>{ updateMinPercentage(set, e); }}
                        on:keyup={(e)=>{ updateMinPercentage(set, e); }}
                    /> %

                </td>
            </tr>
        </table>
        <Button color="secondary" variant="unelevated" class="btn-update" on:click={()=>{
            set.updateImagery();
            ShippingLanesStore.update(); }}>Update Visualisation</Button>
    {/if}
</div>